import { MenuItem } from 'primeng/api';
import { ApiMenuItemDto } from '../models/menu/api-menu-item';

/** Maps API menu tree to PrimeNG Menubar items (relative routerLink segments). */
export function mapApiMenuTreeToPrimeMenu(nodes: ApiMenuItemDto[] | null | undefined): MenuItem[] {
  if (!nodes?.length) return [];
  return [...nodes]
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
    .map((n) => {
      const route = n.routeKey?.trim();
      const childItems = n.children?.length ? mapApiMenuTreeToPrimeMenu(n.children) : undefined;
      const item: MenuItem = {
        label: n.label,
        icon: n.icon ?? undefined,
      };
      if (route) {
        item.routerLink = route;
      }
      if (childItems?.length) {
        item.items = childItems;
      }
      return item;
    });
}
